import React from 'react';
import OptInCtaComponent from './OptInCta';

const OptInCta = ({ data, dispatchReduxAction }) => {
    return(data && 
      <OptInCtaComponent data={data} dispatchReduxAction={dispatchReduxAction}/>
    )
}

export default OptInCta;